import { AppRoutes } from "./routes/appRoutes";
import { ToastContainer } from "react-toastify";
import "animate.css";
import "react-toastify/dist/ReactToastify.min.css";
import { createTheme,ThemeProvider } from "@mui/material";
import { useEffect, useMemo } from "react";
import { useUiStore } from "hooks/useUiStore";
import { AxiosInterceptor } from "api/tribunalAPi";
import { darkTheme } from "styles/muiStylesTheme";

export const ExternosElectronico = () => {
  const { darkMode } = useUiStore();

  const enableThemePrimeFaces = (theme: string) => {
    var head = document.getElementsByTagName("head")[0];
    var firstStyle = head.getElementsByTagName("style")[0];
    head.removeChild(firstStyle);
    document.head
      .querySelector("#primefaces-theme-styles")!
      .setAttribute(
        "href",
        `${process.env.REACT_APP_URL_PUBLIC}assets/theme/indigo/theme-${theme}.css`
      );
  };
  
  const theme = useMemo(() => createTheme(darkTheme(darkMode)), [darkMode]);

  useEffect(() => {
    if (darkMode === "dark") {
      enableThemePrimeFaces("dark");
    } else {
      enableThemePrimeFaces("light");
    }
    // eslint-disable-next-line
  }, [darkMode]);


  return (
    <>
      <ThemeProvider theme={theme}>
        <AxiosInterceptor>
          <AppRoutes />
          <ToastContainer />
        </AxiosInterceptor>
      </ThemeProvider>
    </>
  );
};
